import Entity from "./Entity";
import {Easing, Group, Tween} from "@tweenjs/tween.js";

export default class ChestSurprise extends Entity {

    constructor(anchor, texture) {
        super(anchor, texture);

        this._tweens = new Group();

        this._lidOpen = new PIXI.Sprite(P3.assets.texture("chest_top"));
        this._lidOpen.anchor = anchor;
        this._lidOpen.visible = false;
        this.addChild(this._lidOpen);

        const eyesId = P3.math.randomInt(1, 3);
        const textures = [P3.assets.texture("eyes" + eyesId), P3.assets.texture("eyes" + eyesId + "_1")];

        this._eyes = new PIXI.AnimatedSprite(textures);
        this._eyes.anchor.set(0.5);
        this._eyes.position.set(200, -155);
        this._eyes.looping = true;
        this._eyes.gotoAndPlay(0);
        this._eyes.autoUpdate = false;
        this._eyes.visible = false;
        this.addChild(this._eyes);

        this._chestOpen = new PIXI.Sprite(P3.assets.texture("chest_bottom"));
        this._chestOpen.anchor = anchor;
        this._chestOpen.visible = false;
        this.addChild(this._chestOpen);


        this._activated = false;

    }

    update(dt) {
        this._tweens.update();
        this._eyes.update(dt);
    }

    activate() {
        if (this._activated)
            return;

        this._activated = true;

        this._view.visible = false;

        this._chestOpen.visible = true;
        this._lidOpen.visible = true;
        this._eyes.visible = true;

        /*
        this._doorClosed.visible = false;

        new Tween(this._monster, this._tweens)
            .to({x: this._monster.x - 180}, 600)
            .easing(Easing.Bounce.Out)
            .start();

        new Tween(this._monster.scale, this._tweens)
            .to({x: this._monster.scale.x + 0.01, y: this._monster.scale.y - 0.01}, 600 + Math.random() * 100)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start(Math.random() * 500);

         */
    }

    deactivate() {
        if (this._deactivated)
            return;

        this._deactivated = true;

        this._view.visible = true;
        this._eyes.visible = false;
        //this._chestOpen.visible = false;
        this._lidOpen.visible = false;
    }
}